import { Button } from 'ui';
import { MdEdit } from 'react-icons/md';

type Props = {
  onClick?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
};

export default function EditButton({ onClick }: Props) {
  return (
    <Button
      variant="icon"
      size="none"
      onClick={onClick}
      className="text-gray-dark400 hover:text-gray-dark-6b focus:text-gray-dark-b6"
    >
      <MdEdit className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
}
